export const texts = {
    brand: "LogiLink",
    description: 'Simplify logisitics with magic links.',

    defaultError: '💥 Something went boom.',
    defaultSuccess: '🎉 Success!',

    delete: 'Delete',
    edit: 'Edit',
    cancel: 'Cancel',
    save: 'Save',
    add: 'Add',
    view: 'View',
    confirm: 'Confirm',
    create: 'Create',
    confirmation: 'Confirmation',
    thisActionCannotBeUndone: 'This action cannot be undone.',
    attendees: 'Attendees',
    name: 'Name',
    account: 'Account',
    logout: 'Logout',

    // Login
    emailSentTo: 'Email sent to',
    checkSpamFolder: 'If you don\'t see it, check your spam folder.',
    emailAddress: 'Email Address',
    enterEmail: 'Enter Email',
    login: 'Login',

}
